import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function EquilibriumProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        data-testid="eq-protected-loading"
        className="min-h-screen flex items-center justify-center bg-axiom-bg"
      >
        <div className="flex items-center gap-2 text-axiom-muted text-sm font-mono">
          <span className="signal-dot animate-pulse-signal" />
          AUTHENTICATING...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/equilibrium/login" replace state={{ from: location }} />;
  }

  return children;
}
